import { imgUrl } from "../../utils/helper";

export const contactData = {
  heading: "Contact Us",
  subheading:
    "We’d love to discuss how we can apply our approach to improve the health of your community.",
  title: {
    one: "Let's",
    two: "Create",
    three: "Super Experiece",
  },
  image: imgUrl + "con.png",
  header: [
    { name: "Technology", slug: "technology" },
    { name: "Digital Marketing", slug: "digital_marketing" },
    { name: "Contect Marketing", slug: "contect_marketing" },
  ],
};
